import React, {Component} from 'react'
import LinkWithTooltip from '../../tooltip';

class Separator extends Component {

  onChangeHandle(event){
    const { input: { value, onChange, name } } = this.props
    onChange( event.target.value );
  }

  render(){
    const { input, params } = this.props

    return(
      <div className="sp-pagebuilder-form-group">
        <div className="sp-pagebuilder-admin-separtor">
    		  <span>{params.title}</span>
    		</div>
        {
          typeof params.desc != 'undefined' &&
          <p className="sp-pagebuilder-help-block">{params.desc}</p>
        }
      </div>
    )
  }
}

export default Separator;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Separator.js